<script setup lang="ts">
import type { IconSet, IconStyle, SocialNetwork } from '../../types'
import { getIconDef, resolveIconColors } from '../../utils/socialIcons'

const props = defineProps<{
  network: SocialNetwork
  set?: IconSet
  size?: number
  iconStyle?: IconStyle
}>()

const boxSize = computed(() => props.size ?? 40)
const mode = computed(() => props.iconStyle ?? 'filled')
const set = computed(() => props.set ?? 'brand')

const svgSize = computed(() =>
  mode.value === 'plain' ? Math.round(boxSize.value * 0.65) : Math.round(boxSize.value * 0.55)
)

const colors = computed(() => resolveIconColors(props.network, set.value, mode.value))

const containerStyle = computed(() => {
  const base = { width: `${boxSize.value}px`, height: `${boxSize.value}px` }
  if (colors.value.background) return { ...base, backgroundColor: colors.value.background }
  if (colors.value.ring) return { ...base, border: `2px solid ${colors.value.ring}` }
  return base
})

const icon = computed(() => getIconDef(props.network))
</script>

<template>
  <div
    class="flex shrink-0 items-center justify-center"
    :class="{ 'rounded-full': mode !== 'plain' }"
    :style="containerStyle"
  >
    <svg :width="svgSize" :height="svgSize" viewBox="0 0 24 24" :fill="colors.glyph" xmlns="http://www.w3.org/2000/svg">
      <path v-for="(d, i) in icon.paths" :key="i" :d="d" :fill-rule="icon.fillRule ?? 'nonzero'" />
    </svg>
  </div>
</template>
